// extracted by mini-css-extract-plugin
export var numpadContainer = "_st-1";
export var phoneButton = "_st-0";